"use client"
/* */
const getStatusFromPolicyValidationResult = (result) => {
  if (result.isValid === true) {
    if (result.complexity && result.complexity.actual === result.complexity.min && result.complexity.min !== 4) {
      return "warning";
    }
    return "success";
  } else if (result.isValid === "indeterminate") {
    return "indeterminate";
  }
  return "danger";
};

export { getStatusFromPolicyValidationResult as default, getStatusFromPolicyValidationResult };
//# sourceMappingURL=getStatusFromPolicyValidationResult.mjs.map
